<template>
  <div class="content-box">
    <div class="box-title">
      <span class="title-name" :title="title">{{title}}</span>
      <slot name="headerRight"></slot>
    </div>
    <slot class="box-body" name="boxBody"></slot>
  </div>
</template>
<script>
  export default{
    name: "contentBox",
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data(){
      return {}
    }
  }
</script>
<style lang="scss" scoped>
  .content-box {
    display: inline-block;
    width: 100%;
    /*height: 433px;*/
    height: 100%;
    background-color: #002624;
    box-sizing: border-box;
    border: solid 1px rgba(0, 255, 238, 0.5);

  .box-title {
    height: 30px;
    background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
    background-blend-mode: normal, normal;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-name {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 30px;
    color: #ffffff;
    margin-left: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  }
</style>




// WEBPACK FOOTER //
// src/components/jContentBox.vue